export const SET_PROGRAMMING_TITLE = "PROGRAMACAO_ABATE/SET_PROGRAMMING_TITLE";
export const SET_DEMAND_SAVED = "PROGRAMACAO_ABATE/SET_DEMAND_SAVED";
export const SET_LISTA_DATAS = "PROGRAMACAO_ABATE/SET_LISTA_DATAS";
export const SET_LOADING = "PROGRAMACAO_ABATE/SET_LOADING";
export const SET_PROGRAMMING_SELECTED =
  "PROGRAMACAO_ABATE/SET_PROGRAMMING_SELECTED";
export const SET_LISTA_DEMANDAS = "PROGRAMACAO_ABATE/SET_LISTA_DEMANDAS";
export const SET_ANIMAIS_ITEM_DEMANDAS =
  "PROGRAMACAO_ABATE/SET_ANIMAIS_ITEM_DEMANDAS";
export const SET_PLANTAS_ABATE = "PROGRAMACAO_ABATE/SET_PLANTAS_ABATE";
export const SET_MUNICIPIOS = "PROGRAMACAO_ABATE/SET_MUNICIPIOS";
export const SET_PAGE_BATCHS_AVALIABLE =
  "PROGRAMACAO_ABATE/SET_PAGE_BATCHS_AVALIABLE";
export const SET_BATCHS_AVALIABLE = "PROGRAMACAO_ABATE/SET_BATCHS_AVALIABLE";
export const SET_LIST_EXTENSIONISTAS =
  "PROGRAMACAO_ABATE/SET_LIST_EXTENSIONISTAS";
export const SET_LIST_TIPOS_GENERO = "PROGRAMACAO_ABATE/SET_LIST_TIPOS_GENERO";
export const SET_EDITING_ITEM_BATCH_AVALIABLE =
  "PROGRAMACAO_ABATE/SET_EDITING_ITEM_BATCH_AVALIABLE";
export const SET_PROGRAMACOES_PLANTA =
  "PROGRAMACAO_ABATE/SET_PROGRAMACOES_PLANTA";
export const SET_CITIES = "SLAUGHTER_PROGRAMMING/SET_CITIES";
export const SET_AVAILABLE_LOTS = "SLAUGHTER_PROGRAMMING/SET_AVAILABLE_LOTS";
export const REMOVE_INSERTED_LOTS =
  "SLAUGHTER_PROGRAMMING/REMOVE_INSERTED_LOTS";
export const SET_AVAILABLE_LOTS_META =
  "SLAUGHTER_PROGRAMMING/SET_AVAILABLE_LOTS_META";
export const SET_AVAILABLE_LOTS_CURR_PAGE =
  "SLAUGHTER_PROGRAMMING/SET_AVAILABLE_LOTS_CURR_PAGE";
export const CLEAR_AVAILABLE_LOTS =
  "SLAUGHTER_PROGRAMMING/CLEAR_AVAILABLE_LOTS";
export const CLEAR_ALLOCATED_LOTS = "PROGRAMACAO_ABATE/CLEAR_ALLOCATED_LOTS";
export const CLEAR_DEMAND_VALUES = "PROGRAMACAO_ABATE/CLEAR_DEMAND_VALUES";
export const SET_SLAUGHTER_PLANT_ESTABLISHMENTS =
  "SLAUGHTER_PROGRAMMING/SET_SLAUGHTER_PLANT_ESTABLISHMENTS";
export const SET_SHOW_LOTES_PLANTA_ABATE =
  "PROGRAMACAO_ABATE/SET_SHOW_LOTES_PLANTA_ABATE";
export const SET_LIST_DATES_WITH_DEMAND =
  "PROGRAMACAO_ABATE/SET_LIST_DATES_WITH_DEMAND";
export const SET_LIST_BATCHS_ALLOCATED =
  "PROGRAMACAO_ABATE/SET_LIST_BATCHS_ALLOCATED";
export const SET_DISTANCIA_ESTABELECIMENTO_PLANTA =
  "PROGRAMACAO_ABATE/SET_DISTANCIA_ESTABELECIMENTO_PLANTA";
export const SET_NEW_VALUE_EDIT_WEIGHT =
  "PROGRAMACAO_ABATE/SET_NEW_VALUE_EDIT_WEIGHT";
export const SET_NEW_VALUE_QT_ANIMALS_ALLOCATED =
  "PROGRAMACAO_ABATE/SET_NEW_VALUE_QT_ANIMALS_ALLOCATED";
export const SET_NEW_VALUE_WEIGHT_ALLOCATED =
  "PROGRAMACAO_ABATE/SET_NEW_VALUE_WEIGHT_ALLOCATED";
export const SET_CHECK_LIST_PROGRAMACAO_ABATE_ALOCADO =
  "PROGRAMACAO_ABATE/SET_CHECK_LIST_PROGRAMACAO_ABATE_ALOCADO";
export const SET_NEW_VALUE_PERIODO_CARREGAMENTO_CHECKLIST =
  "PROGRAMACAO_ABATE/SET_NEW_VALUE_PERIODO_CARREGAMENTO_CHECKLIST";
export const SET_LOTE_ALOCADO_QT_ANIMAIS =
  "PROGRAMACAO_ABATE/SET_LOTE_ALOCADO_QT_ANIMAIS";
export const SET_LOTE_ALOCADO_NR_PESO =
  "PROGRAMACAO_ABATE/SET_LOTE_ALOCADO_NR_PESO";
export const REMOVE_LOTE_ALOCADO_WITH_CHECKLIST =
  "PROGRAMACAO_ABATE/REMOVE_LOTE_ALOCADO_WITH_CHECKLIST";
export const RECOVER_LOTE_ALOCADO_WITH_CHECKLIST =
  "PROGRAMACAO_ABATE/RECOVER_LOTE_ALOCADO_WITH_CHECKLIST";
export const REMOVE_LOTE_ALOCADO_WITHOUT_CHECKLIST =
  "PROGRAMACAO_ABATE/REMOVE_LOTE_ALOCADO_WITHOUT_CHECKLIST";
export const CLEAR_LOTE_ALOCADO_LIST =
  "PROGRAMACAO_ABATE/CLEAR_LOTE_ALOCADO_LIST";
export const SET_CAN_EDIT_DEMANDS = "PROGRAMACAO_ABATE/SET_CAN_EDIT_DEMANDS";
export const SET_NEW_STATUS_PROGRAMACAO =
  "PROGRAMACAO_ABATE/SET_NEW_STATUS_PROGRAMACAO";
export const CHANGE_DIALOG_BATCHS_AVALIABLE =
  "PROGRAMACAO_ABATE/CHANGE_DIALOG_BATCHS_AVALIABLE";
export const CLEAR_ALL = "PROGRAMACAO_ABATE/CLEAR_ALL";
export const SET_COPYING = "PROGRAMACAO_ABATE/SET_COPYING"
export const SET_CUTTING = "PROGRAMACAO_ABATE/SET_CUTTING"
export const SET_ID_PROGRAMACAO_ABATE_ALOCADO_TO_COPY = "PROGRAMACAO_ABATE/SET_ID_PROGRAMACAO_ABATE_ALOCADO_TO_COPY"
export const PASTE_PROGAMACAO_ABATE_ALOCADO = "PROGRAMACAO_ABATE/PASTE_PROGAMACAO_ABATE_ALOCADO"
export const CLEAR_PROGAMACAO_ABATE_ALOCADO_TO_COPY = "PROGRAMACAO_ABATE/CLEAR_PROGAMACAO_ABATE_ALOCADO_TO_COPY"